
import { useTranslation } from "react-i18next";
import React, { ReactNode } from "react";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import { CheckBoxControllerType1 } from "./CheckBoxControllerType1";

interface IProps {
  label?: string;
  name?: string;
  id?:string;
  descNode?: ReactNode;
  desc?: string;
  value?: boolean;
  classNameFrame: string;
  classNameInput: string;
  disabledAddClass: string;
  onInputChange: ((it:  boolean) => void)
  disabled?: boolean;
}

const CheckBoxType1: React.FC<IProps> = (props) => {

  const { t } = useTranslation();
  const c = CheckBoxControllerType1<boolean>({ value: props.value ? props.value : false, disabled: props.disabled, classNameFrame: props.classNameFrame, classNameInput: props.classNameInput, disabledClass: props.disabledAddClass })
  //c.setValue(props.value?props.value:false)
  //if((props.value != c.value) && props.value != undefined ) props.onInputChange(props.value)

  return (
    <div>
      {props.label? (<label htmlFor={props.name} className={CSSClassSerivce.labelClass}>{t(props.label ? props.label : "")}</label>):<></> }
      <div 
        ref={(it) => { c.setRefFrame(it) }}
        className={props.classNameFrame}
        onClick={(e) => {
          try {
            if (props.disabled == true) return
            let invertedValue = !c.value
            c.setValue(invertedValue)
            props.onInputChange(invertedValue)
          } catch (e) { }
        }}
      >
        <input
          key={props.value?.toString()}
          ref={(it) => { c.setRefInput(it) }}
          name={props.name}
          id={props.id}
          type="checkbox"
          value={props.label}
          className={props.classNameInput}
          //defaultChecked={props.value}
          checked={c.value as boolean}
          onChange={(e) => {}}
          // onChange={(e)=>{
          //    try { 
          //   //if(c.value == undefined) return
          //   //props.onInputChange(c.value)
          //   //c.setValue(e.target.checked)
          //   //c.value = e.target.checked
          //   //props.onInputChange(e.target.checked)
          //  } catch(e) { } }}
        />
        <label htmlFor={props.label} className="text-sm font-medium ml-2 pointer-events-none">{t(props.desc ? props.desc : "")}</label>
        {props.descNode}
      </div>
    </div>
  );
};

export default CheckBoxType1;